import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
export function Maria() {
  return <section className="py-24 bg-background" data-id="element-105">
      <div className="max-w-5xl mx-auto px-6" data-id="element-106">
        <div className="bg-surface rounded-[2.5rem] border border-border p-8 md:p-12 flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-107">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-1/3 flex justify-center shrink-0" data-id="element-108">
            <div className="w-64 h-64 md:w-72 md:h-72 rounded-full overflow-hidden border-4 border-background shadow-xl bg-surface flex items-center justify-center" data-id="element-109">
              <User size={120} className="text-secondary" strokeWidth={1} data-id="element-110" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-2/3 flex flex-col text-center md:text-left" data-id="element-111">
            <h2 className="text-3xl md:text-4xl font-semibold mb-2" data-id="element-112">
              Марія Йосипівна
            </h2>
            <p className="text-primary font-medium mb-6" data-id="element-113">
              Сертифікований бухгалтер · 20+ років досвіду
            </p>

            <p className="text-secondary leading-relaxed mb-8 text-lg" data-id="element-114">
              Я допомагаю бізнесу вести облік без паперової тяганини і
              несподіваних штрафів. Знаю всі форми оподаткування зсередини — від
              ФОП до складних холдингових структур. Працюю з ПДВ, ЗЕД,
              виробництвом, Дія Сіті. Відповідальність, конфіденційність і
              результат — це не просто слова.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-115">
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-116">
                ТОВ на ПДВ
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-117">
                ЗЕД
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-118">
                Дія Сіті
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-119">
                Виробництво
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-120">
                ІТ-компанії
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-121">
                КІК
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-122">
                Офіс / Дистанційно
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}